import { Division, Goal, HistoricalRecord, PeriodInfo } from '../types'

export function getDivisions(timeframe: 'weekly' | 'monthly'): Division[] {
  if (timeframe === 'weekly') {
    return [
      {
        id: 'div-east',
        name: 'East Region',
        leadId: 'lead-1',
        leadName: 'Sarah Chen',
        teams: [
          {
            id: 'team-alpha',
            name: 'Alpha Team',
            divisionId: 'div-east',
            managerId: 'mgr-1',
            managerName: 'James Wilson',
            loanOfficers: [
              {
                id: 'lo-1',
                name: 'Amanda Foster',
                teamId: 'team-alpha',
                softPullCount: 12,
                submittedCount: 7,
                softPullGoal: 15,
                submittedGoal: 8,
              },
              {
                id: 'lo-2',
                name: 'Brian Nguyen',
                teamId: 'team-alpha',
                softPullCount: 9,
                submittedCount: 4,
                softPullGoal: 15,
                submittedGoal: 8,
              },
              {
                id: 'lo-3',
                name: 'Carla Mendez',
                teamId: 'team-alpha',
                softPullCount: 16,
                submittedCount: 9,
                softPullGoal: 15,
                submittedGoal: 8,
              },
            ],
          },
          {
            id: 'team-beta',
            name: 'Beta Team',
            divisionId: 'div-east',
            managerId: 'mgr-2',
            managerName: 'Lisa Park',
            loanOfficers: [
              {
                id: 'lo-4',
                name: 'Derek Chang',
                teamId: 'team-beta',
                softPullCount: 14,
                submittedCount: 6,
                softPullGoal: 15,
                submittedGoal: 8,
              },
              {
                id: 'lo-5',
                name: 'Elena Volkov',
                teamId: 'team-beta',
                softPullCount: 5,
                submittedCount: 2,
                softPullGoal: 15,
                submittedGoal: 8,
              },
              {
                id: 'lo-6',
                name: 'Frank Okafor',
                teamId: 'team-beta',
                softPullCount: 11,
                submittedCount: 5,
                softPullGoal: 15,
                submittedGoal: 8,
              },
            ],
          },
        ],
      },
      {
        id: 'div-west',
        name: 'West Region',
        leadId: 'lead-2',
        leadName: 'Michael Torres',
        teams: [
          {
            id: 'team-gamma',
            name: 'Gamma Team',
            divisionId: 'div-west',
            managerId: 'mgr-3',
            managerName: 'David Kim',
            loanOfficers: [
              {
                id: 'lo-7',
                name: 'Grace Liu',
                teamId: 'team-gamma',
                softPullCount: 15,
                submittedCount: 8,
                softPullGoal: 15,
                submittedGoal: 8,
              },
              {
                id: 'lo-8',
                name: 'Henry Patel',
                teamId: 'team-gamma',
                softPullCount: 7,
                submittedCount: 3,
                softPullGoal: 15,
                submittedGoal: 8,
              },
              {
                id: 'lo-9',
                name: 'Isabel Reyes',
                teamId: 'team-gamma',
                softPullCount: 13,
                submittedCount: 7,
                softPullGoal: 15,
                submittedGoal: 8,
              },
              {
                id: 'lo-10',
                name: 'Jack Morrison',
                teamId: 'team-gamma',
                softPullCount: 10,
                submittedCount: 5,
                softPullGoal: 15,
                submittedGoal: 8,
              },
            ],
          },
          {
            id: 'team-delta',
            name: 'Delta Team',
            divisionId: 'div-west',
            managerId: 'mgr-4',
            managerName: 'Rachel Green',
            loanOfficers: [
              {
                id: 'lo-11',
                name: 'Kevin Brooks',
                teamId: 'team-delta',
                softPullCount: 14,
                submittedCount: 8,
                softPullGoal: 15,
                submittedGoal: 8,
              },
              {
                id: 'lo-12',
                name: 'Laura Santos',
                teamId: 'team-delta',
                softPullCount: 6,
                submittedCount: 3,
                softPullGoal: 15,
                submittedGoal: 8,
              },
              {
                id: 'lo-13',
                name: 'Marcus Webb',
                teamId: 'team-delta',
                softPullCount: 11,
                submittedCount: 6,
                softPullGoal: 15,
                submittedGoal: 8,
              },
            ],
          },
        ],
      },
    ]
  }

  // Monthly data — higher numbers, day 17 of 28
  return [
    {
      id: 'div-east',
      name: 'East Region',
      leadId: 'lead-1',
      leadName: 'Sarah Chen',
      teams: [
        {
          id: 'team-alpha',
          name: 'Alpha Team',
          divisionId: 'div-east',
          managerId: 'mgr-1',
          managerName: 'James Wilson',
          loanOfficers: [
            {
              id: 'lo-1',
              name: 'Amanda Foster',
              teamId: 'team-alpha',
              softPullCount: 38,
              submittedCount: 22,
              softPullGoal: 50,
              submittedGoal: 30,
            },
            {
              id: 'lo-2',
              name: 'Brian Nguyen',
              teamId: 'team-alpha',
              softPullCount: 25,
              submittedCount: 14,
              softPullGoal: 50,
              submittedGoal: 30,
            },
            {
              id: 'lo-3',
              name: 'Carla Mendez',
              teamId: 'team-alpha',
              softPullCount: 48,
              submittedCount: 28,
              softPullGoal: 50,
              submittedGoal: 30,
            },
          ],
        },
        {
          id: 'team-beta',
          name: 'Beta Team',
          divisionId: 'div-east',
          managerId: 'mgr-2',
          managerName: 'Lisa Park',
          loanOfficers: [
            {
              id: 'lo-4',
              name: 'Derek Chang',
              teamId: 'team-beta',
              softPullCount: 42,
              submittedCount: 19,
              softPullGoal: 50,
              submittedGoal: 30,
            },
            {
              id: 'lo-5',
              name: 'Elena Volkov',
              teamId: 'team-beta',
              softPullCount: 15,
              submittedCount: 8,
              softPullGoal: 50,
              submittedGoal: 30,
            },
            {
              id: 'lo-6',
              name: 'Frank Okafor',
              teamId: 'team-beta',
              softPullCount: 33,
              submittedCount: 17,
              softPullGoal: 50,
              submittedGoal: 30,
            },
          ],
        },
      ],
    },
    {
      id: 'div-west',
      name: 'West Region',
      leadId: 'lead-2',
      leadName: 'Michael Torres',
      teams: [
        {
          id: 'team-gamma',
          name: 'Gamma Team',
          divisionId: 'div-west',
          managerId: 'mgr-3',
          managerName: 'David Kim',
          loanOfficers: [
            {
              id: 'lo-7',
              name: 'Grace Liu',
              teamId: 'team-gamma',
              softPullCount: 46,
              submittedCount: 26,
              softPullGoal: 50,
              submittedGoal: 30,
            },
            {
              id: 'lo-8',
              name: 'Henry Patel',
              teamId: 'team-gamma',
              softPullCount: 20,
              submittedCount: 10,
              softPullGoal: 50,
              submittedGoal: 30,
            },
            {
              id: 'lo-9',
              name: 'Isabel Reyes',
              teamId: 'team-gamma',
              softPullCount: 40,
              submittedCount: 23,
              softPullGoal: 50,
              submittedGoal: 30,
            },
            {
              id: 'lo-10',
              name: 'Jack Morrison',
              teamId: 'team-gamma',
              softPullCount: 30,
              submittedCount: 16,
              softPullGoal: 50,
              submittedGoal: 30,
            },
          ],
        },
        {
          id: 'team-delta',
          name: 'Delta Team',
          divisionId: 'div-west',
          managerId: 'mgr-4',
          managerName: 'Rachel Green',
          loanOfficers: [
            {
              id: 'lo-11',
              name: 'Kevin Brooks',
              teamId: 'team-delta',
              softPullCount: 44,
              submittedCount: 27,
              softPullGoal: 50,
              submittedGoal: 30,
            },
            {
              id: 'lo-12',
              name: 'Laura Santos',
              teamId: 'team-delta',
              softPullCount: 18,
              submittedCount: 9,
              softPullGoal: 50,
              submittedGoal: 30,
            },
            {
              id: 'lo-13',
              name: 'Marcus Webb',
              teamId: 'team-delta',
              softPullCount: 35,
              submittedCount: 20,
              softPullGoal: 50,
              submittedGoal: 30,
            },
          ],
        },
      ],
    },
  ]
}

export function getGoals(): Goal[] {
  return [
    {
      id: 'goal-1',
      metric: 'softPull',
      timeframe: 'weekly',
      target: 15,
      assignmentLevel: 'company',
      effectiveDate: '2026-01-01',
    },
    {
      id: 'goal-2',
      metric: 'submitted',
      timeframe: 'weekly',
      target: 8,
      assignmentLevel: 'company',
      effectiveDate: '2026-01-01',
    },
    {
      id: 'goal-3',
      metric: 'softPull',
      timeframe: 'monthly',
      target: 50,
      assignmentLevel: 'company',
      effectiveDate: '2026-01-01',
    },
    {
      id: 'goal-4',
      metric: 'submitted',
      timeframe: 'monthly',
      target: 30,
      assignmentLevel: 'company',
      effectiveDate: '2026-01-01',
    },
    {
      id: 'goal-5',
      metric: 'softPull',
      timeframe: 'weekly',
      target: 18,
      assignmentLevel: 'loanOfficer',
      assignmentId: 'lo-3',
      effectiveDate: '2026-02-01',
    },
    {
      id: 'goal-6',
      metric: 'submitted',
      timeframe: 'monthly',
      target: 35,
      assignmentLevel: 'team',
      assignmentId: 'team-gamma',
      effectiveDate: '2026-02-01',
    },
  ]
}

export function getHistoricalRecords(): HistoricalRecord[] {
  return [
    // Week 1 — Feb 2-8
    {
      id: 'hr-1',
      periodType: 'weekly',
      startDate: '2026-02-02',
      endDate: '2026-02-08',
      entityType: 'division',
      entityId: 'div-east',
      entityName: 'East Region',
      metric: 'softPull',
      target: 90,
      actual: 95,
      achieved: true,
      percentage: 105.6,
    },
    {
      id: 'hr-2',
      periodType: 'weekly',
      startDate: '2026-02-02',
      endDate: '2026-02-08',
      entityType: 'division',
      entityId: 'div-west',
      entityName: 'West Region',
      metric: 'softPull',
      target: 105,
      actual: 88,
      achieved: false,
      percentage: 83.8,
    },
    {
      id: 'hr-3',
      periodType: 'weekly',
      startDate: '2026-02-02',
      endDate: '2026-02-08',
      entityType: 'team',
      entityId: 'team-alpha',
      entityName: 'Alpha Team',
      metric: 'submitted',
      target: 24,
      actual: 26,
      achieved: true,
      percentage: 108.3,
    },
    // Week 2 — Feb 9-15
    {
      id: 'hr-4',
      periodType: 'weekly',
      startDate: '2026-02-09',
      endDate: '2026-02-15',
      entityType: 'division',
      entityId: 'div-east',
      entityName: 'East Region',
      metric: 'softPull',
      target: 90,
      actual: 82,
      achieved: false,
      percentage: 91.1,
    },
    {
      id: 'hr-5',
      periodType: 'weekly',
      startDate: '2026-02-09',
      endDate: '2026-02-15',
      entityType: 'division',
      entityId: 'div-west',
      entityName: 'West Region',
      metric: 'submitted',
      target: 56,
      actual: 60,
      achieved: true,
      percentage: 107.1,
    },
    {
      id: 'hr-6',
      periodType: 'weekly',
      startDate: '2026-02-09',
      endDate: '2026-02-15',
      entityType: 'loanOfficer',
      entityId: 'lo-3',
      entityName: 'Carla Mendez',
      metric: 'softPull',
      target: 18,
      actual: 20,
      achieved: true,
      percentage: 111.1,
    },
    // Week 3 — Feb 16-22 (current week partial)
    {
      id: 'hr-7',
      periodType: 'weekly',
      startDate: '2026-01-26',
      endDate: '2026-02-01',
      entityType: 'team',
      entityId: 'team-gamma',
      entityName: 'Gamma Team',
      metric: 'softPull',
      target: 60,
      actual: 52,
      achieved: false,
      percentage: 86.7,
    },
    {
      id: 'hr-8',
      periodType: 'weekly',
      startDate: '2026-01-26',
      endDate: '2026-02-01',
      entityType: 'loanOfficer',
      entityId: 'lo-7',
      entityName: 'Grace Liu',
      metric: 'submitted',
      target: 8,
      actual: 9,
      achieved: true,
      percentage: 112.5,
    },
    // Monthly — January
    {
      id: 'hr-9',
      periodType: 'monthly',
      startDate: '2026-01-01',
      endDate: '2026-01-31',
      entityType: 'division',
      entityId: 'div-east',
      entityName: 'East Region',
      metric: 'softPull',
      target: 300,
      actual: 310,
      achieved: true,
      percentage: 103.3,
    },
    {
      id: 'hr-10',
      periodType: 'monthly',
      startDate: '2026-01-01',
      endDate: '2026-01-31',
      entityType: 'division',
      entityId: 'div-west',
      entityName: 'West Region',
      metric: 'softPull',
      target: 350,
      actual: 320,
      achieved: false,
      percentage: 91.4,
    },
    {
      id: 'hr-11',
      periodType: 'monthly',
      startDate: '2026-01-01',
      endDate: '2026-01-31',
      entityType: 'division',
      entityId: 'div-east',
      entityName: 'East Region',
      metric: 'submitted',
      target: 180,
      actual: 175,
      achieved: false,
      percentage: 97.2,
    },
    {
      id: 'hr-12',
      periodType: 'monthly',
      startDate: '2026-01-01',
      endDate: '2026-01-31',
      entityType: 'division',
      entityId: 'div-west',
      entityName: 'West Region',
      metric: 'submitted',
      target: 210,
      actual: 225,
      achieved: true,
      percentage: 107.1,
    },
  ]
}

export function getCurrentPeriod(type: 'weekly' | 'monthly'): PeriodInfo {
  if (type === 'weekly') {
    return {
      type: 'weekly',
      startDate: '2026-02-16',
      endDate: '2026-02-22',
      daysElapsed: 4,
      daysRemaining: 3,
      totalDays: 7,
    }
  }
  return {
    type: 'monthly',
    startDate: '2026-02-01',
    endDate: '2026-02-28',
    daysElapsed: 17,
    daysRemaining: 11,
    totalDays: 28,
  }
}

// Helper functions for goal assignment selection
export function getAllDivisionsForSelection() {
  const divisions = getDivisions('weekly') // Use weekly data as source
  return divisions.map((div) => ({
    id: div.id,
    label: div.name,
  }))
}

export function getAllTeamsForSelection() {
  const divisions = getDivisions('weekly')
  const teams: Array<{ id: string; label: string; category: string }> = []

  for (const division of divisions) {
    for (const team of division.teams) {
      teams.push({
        id: team.id,
        label: team.name,
        category: division.name,
      })
    }
  }

  return teams
}

export function getAllLoanOfficersForSelection() {
  const divisions = getDivisions('weekly')
  const loanOfficers: Array<{ id: string; label: string; category: string }> =
    []

  for (const division of divisions) {
    for (const team of division.teams) {
      for (const lo of team.loanOfficers) {
        loanOfficers.push({
          id: lo.id,
          label: lo.name,
          category: `${team.name} · ${division.name}`,
        })
      }
    }
  }

  return loanOfficers
}
